// getMessageIds.js
'use strict';
import { createSelector } from '../resource/createCachedSelector.js';

/**
 * Select message ids
 * @kind selector
 * @param {!Immutable.Map} state - root state.
 * @return {array} The selected message ids.
 */
const getMessageIds = createSelector(
  state => state.get('messages').keys(),
  ids => [...ids]
);

export default getMessageIds;
